import type { ProductTabType, ProductType } from '@/types'
import { Image } from '@pcln/horizon'
import type { SearchFormTabsItem } from '@pcln/horizon-search-form'
import { tabIconUrls } from '../constants'

const searchFormTabIconUrls: Partial<Record<ProductType, string>> = tabIconUrls

export default function getSearchFormTabsContent(
  productTabs: ReadonlyArray<ProductTabType>,
): ReadonlyArray<SearchFormTabsItem<ProductType>> {
  return productTabs.map((productTab) => {
    const iconUrl = searchFormTabIconUrls[productTab.id]

    return {
      iconLeft: iconUrl
        ? ({ className }) => (
            <Image alt='' src={iconUrl} className={className} isSvg />
          )
        : undefined,
      label: productTab.tabText,
      helperText: `Search for ${productTab.id}`,
      helperTextProps: {
        className: 'sr-only',
      },
      value: productTab.id,
    }
  })
}
